import { MAIN_PATH } from 'production/navigation';

module.exports = {
  path: MAIN_PATH,
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/deviceBatches'),
      ]);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/ProductionManager'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/production/index.js